// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3Ao8_","title":"AfterBackImages_title__W6GkB","images":"AfterBackImages_images__zAiL9"};